import { Card, Button, Heading } from '@enterprise-ui/canvas-ui-react'

export const HomePageCard = ({
  headerText,
  bodyText,
  buttonText,
  onButtonClick,
}) => {
  return (
    <Card
      className="hc-pa-normal hesp-homepage-card"
      data-testid={`homepage-card-${headerText}`}
    >
      <div className="hesp-general-flex hesp-homepage-card-inner">
        <Heading size={3}>{headerText}</Heading>
        <p className="hc-mt-xs">{bodyText}</p>
        <div className="hesp-homepage-card-button-container">
          <Button
            className="hesp-homepage-card-button"
            data-testid={`homepage-card-button-${buttonText}`}
            onClick={onButtonClick}
            type="primary"
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </Card>
  )
}
